import { makeRequest } from '../../../../lib/api';
import {
  CreateOrderCommunicationInterface,
  OrderCommunicationExpiredByOfficeRequestInterface,
} from '../../api/communication';

const ORDER_COMMUNICATION_PATH = '/v1/order_communications';

const communicationController = {
  getOrderCommunications: (orderId): Promise<any> => {
    return makeRequest('get', `${ ORDER_COMMUNICATION_PATH }?orderId=${ orderId }`);
  },

  createOrderCommunication: (request: CreateOrderCommunicationInterface): Promise<any> => {
    return makeRequest('post', ORDER_COMMUNICATION_PATH, request);
  },

  /* editOrderInvoiceDocuments: (id: string, request: EditOrderInvoiceDocumentsRequest): Promise<any> => {
    if (!request?.comment) delete request?.comment;
    return makeRequest('put', `${ ORDER_COMMUNICATION_PATH }/${ id }`, request);
  }, */

  deleteOrderCommunication: (id: string): Promise<any> => {
    return makeRequest('delete', `${ ORDER_COMMUNICATION_PATH }/${ id }`);
  },

  getExpiredCommunications: (): Promise<any> => {
    return makeRequest('get', `${ ORDER_COMMUNICATION_PATH }/expired`);
  },

  getExpiredCommunicationsByOffice: (request: OrderCommunicationExpiredByOfficeRequestInterface): Promise<any> => {
    return makeRequest('get', `${ ORDER_COMMUNICATION_PATH }/expired/by_type?typeRefValueId=${ request.typeRefValueId }${ request.officeId !== 'no-office' ? `&officeId=${ request.officeId }` : '' }`);
  },

};

export { communicationController };
